// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"e2aff205","146":"5b0ad4d9","286":"e13470b0","357":"9d90aa0c","359":"dd787a8a","364":"e54205dd","469":"14f5cd79","495":"c424f305","596":"fc6938fc","636":"ccf55aee","776":"8597ab6c"}[chunkId] + ".chunk.js";
};